<template>
    <div>
        <!-- 订单信息 -->
        <div class="ordernews">
            <h4>订单信息</h4>
            <ul class="clearfloat">
                <li class="clearfloat">
                    <p>订单编号：</p>
                    <span>{{list.check_no}}</span>
                </li>
                <li class="clearfloat">
                    <p>打款时间：</p>
                    <span>{{list.payment_time}}</span>
                </li>
                <li class="clearfloat">
                    <p>打款金额：</p>
                    <span>{{list.payment_price}}</span>
                </li>
                <li class="clearfloat" >
                    <p>物流单号：</p>
                    <span>{{list.express}}</span>
                </li>
                <li class="clearfloat">
                    <p>备注：</p>
                    <span>{{list.remarks}}</span>
                </li>
               
               
            </ul>
        </div>
        <!-- 订单列表 -->
        <div>
            <h4>订单列表</h4>
            <div class="reconciliationTable">
            <el-table
                :data="tableData"
                stripe
                border
                style="width: 100%">
                <el-table-column
                    prop="order_id"
                    label="ID"
                >
                </el-table-column>
                <el-table-column
                    prop="order_no"
                    label="对账单号"
                    show-overflow-tooltip
                   >
                </el-table-column>
                <el-table-column
                    prop="pay_price"
                    label="支付金额"
                   >
                </el-table-column>
                <el-table-column
                    prop="total_price"
                    label="总金额"
                   >
                </el-table-column>
                <el-table-column
                    prop="addtime"
                    label="添加日期"
                    show-overflow-tooltip
                   >
                </el-table-column>
                <el-table-column
                    prop="pay_type"
                    label="支付方式"
                    show-overflow-tooltip
                    >
                </el-table-column>
                <el-table-column
                    prop="payment"
                    label="支付方式"
                    show-overflow-tooltip
                    >
                    <template slot-scope="scope">
                        <span v-show="scope.row.payment==2">工行</span>
                        <span v-show="scope.row.payment==1">微信</span>
                        <span v-show="scope.row.payment==3">支付宝</span>
                    </template>
                </el-table-column>
                    <el-table-column
                    prop="is_revoke"
                    label="是否退款"
                   >
                   <template slot-scope="scope">
                        <span v-show="scope.row.is_revoke==1">已退款</span>
                        <span v-show="scope.row.is_revoke==0">未退款</span>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="is_send"
                    label="是否发货"
                    >
                    <template slot-scope="scope">
                        <span v-show="scope.row.is_send==1">已发货</span>
                        <span v-show="scope.row.is_send==0">未发货</span>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="total_price"
                    label="总金额"
                    show-overflow-tooltip>
                </el-table-column>
                
                <el-table-column
                    prop="pay_price"
                    label="打款金额">
                </el-table-column>
               
            </el-table>
            </div>
            <div class="goods-paging d-flex align-items-center justify-content-center">
				<el-pagination background @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="limit"
					:hide-on-single-page='true' layout="prev, pager, next, total, jumper" :total="znum"></el-pagination>
			</div>
        </div>
    </div>
</template>
<script>
import './reconciliation.css'
export default{
    props:['detailsList'],
    data(){
        return{
           list:{},
           currentPage: 1, //页数
		    limit: 9, //每页条数
            znum:0,
		    page_count: '', //总页数
            tableData:[],
        }
        
    },
    created(){
        this.orderdetailsList()
    },
    methods:{
         // 分页
         handleCurrentChange(e) {
				this.currentPage= e;
                this.orderdetailsList()	
		},
        orderdetailsList(){
            this.$api.orderDetail({
				shop_type: 'qycg',
                check_id:this.detailsList.id,
                page: this.currentPage,
                limit: this.limit,
			}).then(res => {
                if(res.code==0){
                    this.list=res.data.info
                    this.tableData=res.data.list
                    this.znum = Number(res.data.row_count);
                    this.page_count = res.data.page_count;
                
                }else{
                    this.$message({
                        showClose: true,
                        message: res.msg,
                        type: 'warning',
                        offset: 200,
                        duration: 1000
                    })
                }
			}).catch(err => {
						// console.log(err);
			});
        }
        
    }
}
</script>
<style lang="scss" scoped>
.ordernews {
	width: 100%;
	margin-bottom: 20px;
	background: #fff;
	// padding: 32px;
	box-sizing: border-box;

	h4 {
		font-size: 16px;
		// color: #999;
		font-weight: 500;
		line-height: 16px;
		margin-bottom: 10px;
	}

	ul {
		li {
			float: left;
			width: 32%;
			margin-right: 2%;

			&:nth-child(3n) {
				margin-right: 0;
			}

			p {
				float: left;
				font-size: 12px;
				color: #666;
				font-weight: 400;
				line-height: 24px;
				text-align: right;
				width: 80px;
				margin-right: 10px;
			}

			span {
				float: left;
				font-size: 12px;
				color: #333;
				font-weight: 400;
				line-height: 24px;
			}
		}
	}
}
</style>